import { Timer } from "three";
import { now } from "@messages/timing";
import { animationFrame$ } from "@messages/xr/AnimationFrame";
class ClockService {
    constructor() {
        this.clock = new Timer();
        // when we pause (onBlur) we store the timescale here for later resume
        this.pausedTimescale = 1;
        this.shaderMaterials = {};
        this.lastUpdateTime = now();
        this.onFrame = () => {
            this.clock.update();
            this.passedSeconds = this.clock.getDelta();
            for (const key in this.shaderMaterials) {
                if (this.shaderMaterials.hasOwnProperty(key)) {
                    const material = this.shaderMaterials[key].material;
                    const options = this.shaderMaterials[key].options || {};
                    if (!material.uniforms) {
                        console.warn("[xr] Material " + key + " in Clockservice has no uniforms. Is it a ShaderMaterial?");
                    }
                    else {
                        if (!material.uniforms[options.name || "time"]) {
                            material.uniforms[options.name || "time"] = { value: 0 };
                        }
                        material.uniforms[options.name || "time"].value += (options.factor || 1.0) * this.passedSeconds;
                    }
                }
            }
        };
        this.passedSeconds = this.clock.getDelta();
    }
    init() {
        animationFrame$.add(this.onFrame);
    }
    getDeltaToLastFrameInSeconds() {
        return this.passedSeconds;
    }
    getElapsedTime() {
        return this.clock.getElapsed();
    }
    /**
     * add a Material to inject time into on every frame
     * @param key a key to store the material under
     * @param material the material
     * @param options an optional set of Options with these values:
     *   {
     *      factor: float => a factor tzo apply to passed seconds, before injecting in the shader
     *      name: String => name of the shader variable. Defaults to time
     *   }
     */
    addShaderMaterial(key, material, options) {
        if (!key) {
            console.warn("[xr] Key must be defined in ClockService.addShaderMaterial");
            return;
        }
        if (!material) {
            console.warn("[xr] Material must be defined in ClockService.addShaderMaterial");
            return;
        }
        this.shaderMaterials[key] = {
            material: material,
            options: options
        };
    }
    remove(key) {
        if (!key) {
            console.warn("[xr] Key must be defined in ClockService.remove");
            return;
        }
        delete this.shaderMaterials[key];
    }
    resume() {
        this.clock.setTimescale(this.pausedTimescale);
    }
    pause() {
        this.pausedTimescale = this.clock.getTimescale();
        this.clock.setTimescale(0);
    }
}
export const clockService = new ClockService();
